/* ============================================================
   /search page enhancements (overlay onto Dawn's existing markup):
   1. Inject a dynamic heading under the input: 'Resultados para "X" · N productos'.
   2. Strict-match filter: hide products whose TITLE doesn't contain every
      word from the query (only when query has 2+ words) — mirrors the
      predictive search behaviour so "jordan 4" no longer shows Jordan 6 / CJ1.
   ============================================================ */
(function () {
  if (window.__slSearchInit) return;
  window.__slSearchInit = true;

  // --- Token helpers (mirror predictive search filter) ---
  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function tokenize(text) {
    return normalize(text)
      .split(/[\s\-_/.,()\[\]&|:;!?"'`+]+/)
      .filter(Boolean);
  }

  var NUMERIC_RE = /^\d+$/;

  function termMatchesTokens(tokens, term) {
    if (NUMERIC_RE.test(term)) return tokens.indexOf(term) !== -1;
    for (var i = 0; i < tokens.length; i++) {
      if (tokens[i].indexOf(term) === 0) return true;
    }
    return false;
  }

  function getQueryTerms() {
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim();
    if (!q) return { raw: '', terms: [] };
    var terms = normalize(q).split(/\s+/).filter(Boolean);
    return { raw: q, terms: terms };
  }

  // --- Dynamic heading ---
  function injectHeading() {
    var existing = document.querySelector('.sl-search-dynamic-heading');
    if (existing) return existing;
    var anchor = document.querySelector('.template-search__search');
    if (!anchor) return null;
    var heading = document.createElement('p');
    heading.className = 'sl-search-dynamic-heading';
    anchor.insertAdjacentElement('afterend', heading);
    return heading;
  }

  function getTotalResults() {
    // Server-rendered total (search.results_count) — survives single-word
    // queries where strict-match doesn't run, and reflects all pages, not
    // just the 24 visible on the current paginate page.
    var root = document.querySelector('[data-sl-search-total]');
    if (!root) return null;
    var n = parseInt(root.getAttribute('data-sl-search-total'), 10);
    return isFinite(n) ? n : null;
  }

  function updateHeading(visibleCount) {
    var q = getQueryTerms();
    var heading = injectHeading();
    if (!heading) return;
    if (!q.raw) {
      heading.style.display = 'none';
      return;
    }
    heading.style.display = '';

    var total = getTotalResults();
    // Multi-word strict-match: prefer the post-filter visible count (the
    // value reflects what the user actually sees). Single-word or no
    // filtering: use the server total so we don't lie about the count
    // when there are more pages.
    var count = (q.terms.length >= 2 && visibleCount !== null) ? visibleCount : (total !== null ? total : visibleCount);

    if (!count || count === 0) {
      heading.innerHTML = 'Sin resultados para "' + escapeHtml(q.raw) + '"';
    } else {
      heading.innerHTML =
        'Resultados para "' + escapeHtml(q.raw) + '"' +
        '<span class="sl-search-dynamic-heading__count"> · ' + count + ' resultado' + (count === 1 ? '' : 's') + '</span>';
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]);
    });
  }

  // --- Strict-match ---
  function applyStrictMatch() {
    var q = getQueryTerms();
    var allItems = document.querySelectorAll('.template-search__results .grid__item[data-product-title]');
    if (allItems.length === 0) {
      // No products on the page (empty state). Heading shows the raw count from Dawn.
      updateHeading(0);
      return;
    }

    if (q.terms.length < 2) {
      // Single-word queries (or none): trust Shopify's ranking, no client-side filter.
      allItems.forEach(function (item) { item.classList.remove('sl-strict-hidden'); });
      updateHeading(allItems.length);
      return;
    }

    var visible = 0;
    allItems.forEach(function (item) {
      var title = item.getAttribute('data-product-title') || '';
      var tokens = tokenize(title);
      var matches = q.terms.every(function (term) { return termMatchesTokens(tokens, term); });
      if (matches) {
        item.classList.remove('sl-strict-hidden');
        visible++;
      } else {
        item.classList.add('sl-strict-hidden');
      }
    });
    updateHeading(visible);
  }

  // --- Re-run after Dawn's facets AJAX swaps the product grid ---
  function observeGridChanges() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var observer = new MutationObserver(function () { applyStrictMatch(); });
    observer.observe(container, { childList: true, subtree: true });
  }

  // --- Load more: AJAX append next page ---
  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sl-search-load-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var originalText = btn.textContent;
      btn.textContent = 'Cargando…';

      fetch(btn.href, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.querySelector('.template-search .product-grid');
          var newItems = doc.querySelectorAll('.template-search .product-grid > li');
          newItems.forEach(function (li) {
            // re-apply strict-match attribute check then append
            grid.appendChild(li);
          });

          var wrapper = btn.closest('.sl-search-load-more-wrapper');
          var nextWrapper = doc.querySelector('.sl-search-load-more-wrapper');
          if (nextWrapper && wrapper) {
            wrapper.replaceWith(nextWrapper);
          } else if (wrapper) {
            wrapper.remove();
          }

          applyStrictMatch();
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          btn.textContent = originalText;
        });
    });
  }

  function init() {
    applyStrictMatch();
    observeGridChanges();
    initLoadMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
